/** Appended to or stored in `salary_range` when the screener should ask the candidate for compensation expectations. */
export const ASK_SALARY_EXPECTATIONS_PHRASE =
  "Ask the candidate for their expectations.";

export const salaryRangeAsksCandidateExpectations = (
  salaryRange: string | null | undefined,
): boolean => {
  return (salaryRange ?? "").includes(ASK_SALARY_EXPECTATIONS_PHRASE);
};

/** Numeric range text from `salary_range`, excluding the ask-expectations instruction line. */
export const salaryRangeDisclosedPart = (
  salaryRange: string | null | undefined,
): string | null => {
  if (salaryRange === null || salaryRange === undefined) return null;
  let value = salaryRange.trim();
  if (!value) return null;
  if (salaryRangeAsksCandidateExpectations(value)) {
    value = value.replace(ASK_SALARY_EXPECTATIONS_PHRASE, "").trim();
  }
  return value || null;
};

export const parseSalaryRangeAmount = (
  salaryRange: string | null | undefined,
): string | null => {
  const disclosed = salaryRangeDisclosedPart(salaryRange);
  if (disclosed === null) return null;

  const salaryLower = disclosed.toLowerCase();
  for (const period of ["year", "month", "week", "day", "hr", "hour"]) {
    if (salaryLower.includes(`per ${period}`)) {
      return disclosed
        .substring(0, salaryLower.indexOf(`per ${period}`))
        .trim();
    }
  }
  return disclosed;
};

export const parseSalaryRangePeriod = (
  salaryRange: string | null | undefined,
): string | null => {
  const disclosed = salaryRangeDisclosedPart(salaryRange);
  if (disclosed === null) return null;

  const salaryLower = disclosed.toLowerCase();
  for (const period of ["year", "month", "week", "day", "hr", "hour"]) {
    if (salaryLower.includes(`per ${period}`)) {
      if (period === "hr" || period === "hour") {
        return "hour";
      }
      return period;
    }
  }
  return "";
};

export const buildSalaryRangeStored = (
  amount: string,
  period: string,
  askExpectations: boolean,
): string => {
  let salaryRange = "";
  const trimmedAmount = amount.trim();
  if (trimmedAmount) {
    salaryRange = period.trim()
      ? `${trimmedAmount} per ${period.trim()}`
      : trimmedAmount;
  }
  if (askExpectations) {
    salaryRange = salaryRange
      ? `${salaryRange}\n${ASK_SALARY_EXPECTATIONS_PHRASE}`
      : ASK_SALARY_EXPECTATIONS_PHRASE;
  }
  return salaryRange;
};
